import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { ModalAction } from '../../Store/Modal-Slice';
import amplitude from 'amplitude-js';
import Notify from '../Comments/boostbtnsvg/Notify';
import { NotifyApi } from '../../utils/API/PhotoListApi';

const FeedMeta = ({
    props,
    OtheruserProfileNavigateHandler,
    MainImgHandler,
    voteHandler,
    SharePhotobtnHandler,
    FollowHandler,
    CongratulationssHandler,
    BoostState,
    BoostSvgs,
    setIsModalOpen,
    address,
    formattedDate,
    formattedLikes,
    votebtnactive,
    follow,
    IsCongratulate,
    comingUp,
    UserPaymentStatus
}) => {

    const [IsNotify, setIsNotify] = useState(props.is_notify)
    const [IsLoading, setIsLoading] = useState(false)

    const dispatch = useDispatch();
    const handleVoteClick = () => {
        if (props.isLoggedIn) {
            voteHandler();
        } else {
            dispatch(ModalAction.setPopupModalMessage({
                joinModalHeading: "to upvote",
                popupHeading: "Your Upvote is Official.",
                popupMessage: "You’re in! Don’t forget to check your email Tuesday to see if this photo is one of the week’s most upvoted.",
                photoID: props.postId,
                userID: props.Userid,
            }));
            dispatch(ModalAction.setJoinNowModalState(true));
        }
    };

    if (props.congBtn) {
        return (
            <div className="feed_meta">
                <div className="feed_author">
                    <div className="avatar">
                        <a
                            onClick={props.isLoggedIn ? OtheruserProfileNavigateHandler : MainImgHandler}
                        >
                            <img
                                src={props.UserPhoto || `https://ui-avatars.com/api/?name=${props.Name}&size=40&rounded=true&background=01655a&color=fff`}
                                alt="user"
                            />
                        </a>
                    </div>
                    <div className="author_text">
                        <a
                            className="user_name"
                            onClick={props.isLoggedIn ? OtheruserProfileNavigateHandler : MainImgHandler}
                        >
                            {props.Name}
                        </a>
                        <div className="author_meta">
                            {address && <span className="location">{address}</span>}
                            <span className="date">{formattedDate}</span>
                        </div>
                    </div>
                </div>

                <a
                    onClick={SharePhotobtnHandler}
                    className="feed_share ms-auto d-md-none"
                >
                    <img src="./assets/img/icons/share-icon-black.svg" alt="" className="img-fluid share-img" />
                </a>

                {props.loginUserid !== props.Userid && (
                    <a
                        className="btn btn-follow feed_follow d-md-none"
                        onClick={props.isLoggedIn ? FollowHandler : MainImgHandler}
                    >
                        <img
                            className="follow"
                            src="./assets/img/icons/follow.svg"
                            alt=""
                            style={{ display: !follow ? 'inline' : 'none', filter: !follow ? 'invert(1)' : '' }}
                        />
                        <img
                            className="following"
                            src="./assets/img/icons/following.svg"
                            alt=""
                            style={{ display: follow ? 'inline' : 'none' }}
                        />
                    </a>
                )}

                <div className="feed_meta_right">
                    <a
                        onClick={SharePhotobtnHandler}
                        className="feed_share d-none d-md-inline-flex"
                    >
                        <img src="./assets/img/icons/share-icon-black.svg" alt="" className="img-fluid share-img" />
                        Share
                    </a>

                    {props.loginUserid !== props.Userid && (
                        <a
                            className="btn btn-follow feed_follow d-none d-md-inline-flex"
                            onClick={props.isLoggedIn ? FollowHandler : MainImgHandler}
                        >
                            <img
                                className="follow"
                                src="./assets/img/icons/follow.svg"
                                alt=""
                                style={{ display: !follow ? 'inline' : 'none', filter: !follow ? 'invert(1)' : '' }}
                            // style={{ ' }}
                            />
                            <img
                                className="following"
                                src="./assets/img/icons/following.svg"
                                alt=""
                                style={{ display: follow ? 'inline' : 'none' }}
                            />
                            <span className="follow" style={{ display: !follow ? 'inline' : 'none' }}>Follow</span>
                            <span className="following" style={{ display: follow ? 'inline' : 'none' }}>Following</span>
                        </a>
                    )}

                    {props.congBtn && props.loginUserid !== props.Userid && (!IsCongratulate ? <a onClick={props.isLoggedIn ? CongratulationssHandler : MainImgHandler} className="btn cong-btn cong-not-send" style={{ gap: "5px", flexGrow: "1" }} >
                        <img src="./assets/img/icons/star.svg" className="img-fluid cong-img" alt="img" />
                        <span>Congratulations!</span>
                    </a> :
                        <a style={{ cursor: "default", gap: "10px", padding: "10px 27px", border: 'solid 1px gray', flexGrow: "1" }} className="btn cong-btn cong-send">
                            <img src="./assets/img/icons/green2-star.svg" className="img-fluid cong-img" alt="img" />
                            <span>Congratulated</span>
                        </a>)}

                    <div className="feed_vote">
                        <a
                            onClick={handleVoteClick}
                            className={`btn btn-vote ${votebtnactive ? "active" : ""}`}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M18 15L12 9L6 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            {formattedLikes}
                        </a>
                    </div>
                </div>
            </div>
        );
    }



    const NotifyHandler = async () => {
        NotifyApi(props.postId, props.Userid, setIsNotify, setIsLoading)
    }

    // Original return statement for when props.congBtn is false
    return (
        <div className="feed_meta">
            <div className="feed_author">
                <div className="avatar">
                    <a
                        className="user_img"
                        onClick={props.isLoggedIn ? OtheruserProfileNavigateHandler : MainImgHandler}
                        style={{
                            backgroundImage: `url(${props.UserPhoto || ""})`,
                            backgroundPosition: "center",
                            backgroundSize: "cover",
                            backgroundRepeat: "no-repeat",
                            borderRadius: "50%",
                            cursor: "pointer",
                        }}
                    >
                        {!props.UserPhoto && (
                            <img
                                src={`https://ui-avatars.com/api/?name=${props.Name}&size=40&rounded=true&background=01655a&color=fff`}
                                alt="img"
                            />
                        )}
                    </a>
                </div>
                <div className="author_text">
                    <a
                        className="user_name"
                        onClick={props.isLoggedIn ? OtheruserProfileNavigateHandler : MainImgHandler}
                    >
                        {props.Name}
                    </a>
                    <div className="author_meta">
                        {address && <span className="location">{address}</span>}
                        <span className="date">{formattedDate}</span>
                    </div>
                </div>
            </div>

            <div className="feed_vote d-md-none">
                {!comingUp ? <a onClick={handleVoteClick} className={`btn btn-vote ${props.congBtn ? "weeklyTop10Linke-btn" : ''} ${votebtnactive ? "active" : ""}`}>
                    <img src="./assets/img/icons/arrow-up.svg" alt="img" />
                    <span>{formattedLikes}</span>
                </a> : (<a onClick={() => { if (!IsNotify) NotifyHandler(); }} className="btn notify-btn " style={{ backgroundColor: IsNotify ? ' #CDCED2' : '#FFD621', cursor: IsNotify ? " default" : "pointer" }}>
                    {IsLoading ? <span className="loader"></span> : <>
                        <Notify />
                        {IsNotify ? "Notify Set" : "Notify Me"}
                    </>}
                </a>)}
            </div>

            <div className="feed_meta_right">
                <a onClick={SharePhotobtnHandler} className="feed_share">
                    <img src="./assets/img/icons/share-icon-black.svg" alt="img" className="img-fluid share-img" />
                    Share
                </a>

                {props.loginUserid !== props.Userid ? (
                    <a className="btn btn-follow feed_follow">
                        {!follow ? (
                            <span
                                onClick={props.isLoggedIn ? FollowHandler : MainImgHandler}
                                className="btn btn-follow follow"
                                style={{ width: "90px" }}
                            >
                                <img src="./assets/img/icons/follow.svg" alt="img" style={{ filter: "invert(1)" }} />
                                <span style={{ color: "#37394b", fontWeight: "500" }}>Follow</span>
                            </span>
                        ) : (
                            <span
                                onClick={FollowHandler}
                                className="btn btn-follow"
                                style={{ width: "90px" }}
                            >
                                <img style={{ height: "28px" }} src="./assets/img/icons/following.svg" alt="img" />
                                <span style={{ color: "#37394b", fontWeight: "500" }}>Following</span>
                            </span>
                        )}
                    </a>
                ) : (
                    BoostState && props.show && (
                        <a
                            style={{
                                cursor: !["Rehunted", "Rehunted_Before"].includes(BoostState) ? "pointer" : "default",
                            }}
                            className={`btn boost_btn ${BoostState === "Rehunt" ? "" : BoostState === "Expired" ? "expired" : "boosted"
                                }`}
                            onClick={
                                !["Rehunted", "Rehunted_Before"].includes(BoostState)
                                    ? () => {
                                        setIsModalOpen(true);
                                        if (BoostState === "Rehunt" && !UserPaymentStatus) {
                                            amplitude.getInstance().logEvent("Rehunt Not Paid");
                                        }
                                    }
                                    : null
                            }
                        >
                            {BoostState === "Rehunted_Before" ? "Rehunted" : BoostState}
                            <span className="icon">{BoostSvgs?.[BoostState]}</span>
                        </a>

                    )
                )}

                {props.congBtn && props.loginUserid !== props.Userid && (
                    !IsCongratulate ? (
                        <a
                            onClick={props.isLoggedIn ? CongratulationssHandler : MainImgHandler}
                            className="btn cong-btn cong-not-send"
                            style={{ gap: "5px" }}
                        >
                            <img src="./assets/img/icons/star.svg" className="img-fluid cong-img" alt="img" />
                            <span>Congratulations!</span>
                        </a>
                    ) : (
                        <a
                            style={{ cursor: "default", gap: "5px", padding: "10px 27px", border: "solid 1px gray" }}
                            className="btn cong-btn cong-send"
                        >
                            <img src="./assets/img/icons/green2-star.svg" className="img-fluid cong-img" alt="img" />
                            <span>Congratulated</span>
                        </a>
                    )
                )}

                <div className="feed_vote d-none d-md-inline-flex">
                    {!comingUp ? <a onClick={handleVoteClick} className={`btn btn-vote ${props.congBtn ? "weeklyTop10Linke-btn" : ''} ${votebtnactive ? "active" : ""}`}>
                        <img src="./assets/img/icons/arrow-up.svg" alt="img" />
                        <span>{formattedLikes}</span>
                    </a> : (<button onClick={() => { if (!IsNotify) NotifyHandler(); }} className="btn notify-btn " style={{ backgroundColor: IsNotify ? ' #CDCED2' : '#FFD621', cursor: IsNotify ? " default" : "pointer" }}>
                        {IsLoading ? <span className="loader"></span> : <>
                            <Notify />
                            {IsNotify ? "Notify Set" : "Notify Me"}
                        </>}
                    </button>)}
                </div>
            </div>
        </div>
    );
};

export default FeedMeta;